export const benefits = [
  { label: "Si", value: "YES" },
  { label: "No", value: "NO" }
]
